import {RESS,RID,RISK} from '../../content/ressorts';
import { useGame, useS } from '../../store/game';
import { Panel, Avatar, Dots } from '../../components/ui';

import { PA, PN } from '../../engine/rules';
import { blocker } from '../../engine/budget';
import { dateLabel } from '../../engine/util';
import { Illu } from '../../components/Illu';

export function Attrs({ M }: { M: any }) {
  return <div className="attrs"><span>Kompetenz <Dots n={M.k} /></span><span>Loyalität <Dots n={M.l} /></span><span>Skandalrisiko <b className={['up', 'warn', 'down'][M.r]}>{RISK[M.r]}</b></span></div>;
}

export function Kabinett() {
  const S = useS(); const { dispatch } = useGame();
  const own = RESS.filter((r: any) => S.min[r.id].p === 'YOU').length;
  const blk = blocker();
  return (
    <Panel title="Bundeskabinett" aside={`${own} von ${RESS.length} Ressorts bei ${PA('YOU')}`}>
      <p className="sub">Kompetenz verkürzt die Arbeit an Gesetzentwürfen und verstärkt ihre Wirkung. Illoyale Minister widersprechen öffentlich, riskante geraten eher in Affären. Führt ein Partner das Ressort und mag er einen Entwurf nicht, verschleppt sein Haus die Arbeit.</p>
      <div className="mins">{RESS.map((r: any) => { const M = S.min[r.id]; return (
        <div key={r.id} className={'mcard' + (S.scandal && S.scandal.rid === r.id ? ' hotm' : '')}><Avatar M={M} /><div className="mi"><span className="label">{r.n}</span><b>{M.n}</b>
          <span className="sub">{PN(M.p)}{M.tag ? ` · ${M.tag}` : ''} · seit {dateLabel(M.since || 0)}</span><Attrs M={M} />
          {M.p === 'YOU' && !blk && <div><button type="button" className="small" onClick={() => dispatch('reshuffle', r.id)}>Ersetzen</button></div>}</div></div>); })}</div>
    </Panel>
  );
}

export function ScandalCard() {
  const S = useS(); const { dispatch } = useGame(); const sc = S.scandal, M = S.min[sc.rid];
  return (
    <div className="decision hotd"><Illu src="/img/moment/skandal.webp" className="illu card" /><span className="label">Affäre · {RID[sc.rid].n}</span>
      <div className="mrow"><Avatar M={M} size="lg" /><div className="mi"><h3>{sc.t}</h3><span className="sub">{M.n} ({PA(M.p)}) steht unter Druck. Opposition und Presse fordern den Rücktritt.{M.p !== 'YOU' ? ' Das Ressort gehört eurem Koalitionspartner, er bestimmt die Nachfolge.' : ''}</span></div></div>
      <div className="actions"><button type="button" className="yes small" onClick={() => dispatch('scandal', true)}>Rücktritt annehmen</button><button type="button" className="small" onClick={() => dispatch('scandal', false)}>Festhalten</button></div>
      <span className="sub">Festhalten schont das Kabinett. Eskaliert die Affäre aber weiter, wird es deutlich teurer.</span></div>
  );
}

export function PickCard() {
  const S = useS(); const { dispatch } = useGame(); const P = S.pickFor, r = RID[P.rid];
  return (
    <div className="decision"><span className="label">Personalentscheidung · {r.n}</span><h3>{P.why === 'skandal' ? 'Wer übernimmt nach dem Rücktritt?' : 'Wen holt ihr ins Kabinett?'}</h3>
      <div className="cands">{P.c.map((M: any, i: number) => <div className="mcard" key={i}><Avatar M={M} /><div className="mi"><span className="tagline">{M.tag}</span><b>{M.n}</b><Attrs M={M} /><div><button type="button" className="small yes" onClick={() => dispatch('appoint', i)}>Ernennen</button></div></div></div>)}</div>
      {P.why === 'umbildung' && <div className="actions"><button type="button" className="small" onClick={() => dispatch('pickCancel')}>Abbrechen</button></div>}</div>
  );
}
